import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Atlas = Loadable({
    loader: () => import(/* webpackChunkName: "Atlas" */ './atlas'),
    loading: () => <div />,
});
